module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "1%"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "searchs"
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "line-height": "30px"
    }
  }, [_vm._v("搜索内容：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入户名或表号用以检索",
      "size": "small"
    },
    model: {
      value: (_vm.searchContent),
      callback: function($$v) {
        _vm.searchContent = $$v
      },
      expression: "searchContent"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "type": "info",
      "size": "small"
    }
  }, [_vm._v("搜索")])], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.tableData,
      "row-class-name": _vm.tableRowClassName,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "billTime",
      "label": "账单时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hname",
      "label": "户名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hno",
      "label": "户号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPay",
      "label": "缴费状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isPay == 1) ? _c('span', [_vm._v("已缴")]) : _vm._e(), _vm._v(" "), (scope.row.isPay == 2) ? _c('span', [_vm._v("未缴")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge",
      "label": "当期金额",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useWater",
      "label": "用水量",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "抄表图片",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "60%",
            "height": "40px"
          },
          attrs: {
            "src": scope.row.image
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleClick(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "margin-right": "5%"
    },
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.totalSize
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ce29451","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/BillNum.vue
// module id = 1774
// module chunks = 1